<template>
<transition name="modal">
        <div class="modal-mask" id="helper_diagnoses" v-click-outside="off">
            <div >
                <b-list-group>
                    <b-list-group-item @click="chooseItem(item)" class="diag-item" v-for="item in items" :key="item.ID">{{ item.MKB_NAME }}</b-list-group-item>
                </b-list-group>
            </div>
        </div>
</transition>
</template>

<script>
import ClickOutside from '@app/directives/click-outside.directive';

export default {
    props: {
        items: Array,
        positionLeft: Number,
        positionTop: Number
    },
    directives: {
        ClickOutside
    },
    mounted() {
        document.getElementById('helper_diagnoses').style.left = this.positionLeft + 'px';
        document.getElementById('helper_diagnoses').style.top = this.positionTop + 'px';
    },
    methods: {
        off() {
            this.$emit('clickOutside');
        },
        chooseItem(item) {
            this.$emit('addItem', item);
        }
    }
};
</script>

<style lang="scss" scoped>
.diag-item:hover {
    background: dodgerblue;
    color: white;
    cursor: pointer;
}




.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 170px;
  left: 0;
  width: 300px;
  height: 300px;
  overflow: auto;
  background: linear-gradient(to right, whitesmoke, white);
  box-shadow: 5px 0 5px 0 gray;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: opacity 0.3s ease;
}
.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

</style>